
































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IContractProduct } from "@/models/contracts";
import { Location } from "vue-router";
import CProdMixin from "@/mixins/cProdMixin";
import Context from "@/mixins/context";
import _ from "@/boot/lodash";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "cprod-status-summary": () =>
      import("@/components/app/global/contractProducts/cProdStatusSummary.vue"),
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class CProdGridItem extends Mixins(Context, CProdMixin) {
  // Props

  @Prop({ default: undefined })
  public readonly cProd!: IContractProduct;

  @Prop({ default: null })
  public readonly clientId!: IClient["id"];

  @Prop({ default: false })
  public readonly isLoading!: boolean;

  @Prop({ default: false })
  public readonly showSkeletons!: boolean;

  // Methods

  public get cProdClient() {
    return this.cProd?.clients?.[0];
  }

  public get cProdClientAvatarBindings() {
    return {
      size: 32,
      name: this.cProdClient?.fullname,
      email: this.cProdClient?.email,
      src: this.cProdClient?.image_url
    };
  }

  public get cProdRoute(): Location {
    return this.constructRoute(
      this.isMockClientContext
        ? "admin__upmindClientCProd"
        : this.isClient
        ? "clientCProd"
        : "admin__clientCProd"
    );
  }

  public get cProdProvisioningRoute(): Location {
    return this.constructRoute(
      this.isMockClientContext
        ? "admin__upmindClientCProdProvisioning"
        : this.isClient
        ? "clientCProdProvisioning"
        : "adminClientCProdProvisioning"
    );
  }

  public get iconBindings() {
    const request = _.first(this.cProd?.unresolved_provision_requests);
    if (!request) return {};
    return {
      icon: "exclamation-triangle",
      iconLabel: [request.function_name, request.result_message].join(": "),
      iconRouterLink: this.cProdProvisioningRoute,
      iconType: "is-danger"
    };
  }

  // Methods

  public constructRoute(name: Location["name"]): Location {
    if (!this.cProd) return {};
    return {
      name,
      params: {
        clientId: this.clientId
          ? this.clientId
          : this.cProd?.clients?.[0]?.id ?? "",
        contractId: this.cProd?.contract_id,
        productId: this.cProd?.id
      }
    };
  }
}
